export default "__VITE_ASSET__88505269__"